import colors from './themeProperties/colors';
import zIndices from './themeProperties/zIndices';

const theme = {
  colors,
  zIndices,
};
export default theme;

export type Theme = typeof theme;
